import {
  StyleRulesCallback,
  WithStyles,
  withStyles as withStylesCb
} from "@material-ui/core/styles";

export const styles: StyleRulesCallback = ({ palette, spacing: { unit } }) => ({
  container: {
    backgroundColor: palette.grey["100"],
    margin: `${unit * 4}px 0`,
    padding: unit * 3
  }
});

export type Styles = WithStyles<typeof styles>;
export const withStyles = withStylesCb(styles);
